const initialState = {
  attributesTypes: [],
  statuses: ['enabled', 'disabled'],
  currentlyEditedAttribute: null
}
export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setAttributesTypes(state, data) {
      state.attributesTypes = data
    },
    setCurrentlyEditedAttribute(state, data) {
      state.currentlyEditedAttribute = data
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    getAttributesTypesList({ dispatch, commit }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesTypes.getList',
          payload
        },
        { root: true }
      )
        .then((response) => {
          commit('setAttributesTypes', response.data.data)
          return response.data
        })
        .catch((e) => {
          throw e
        })
    },
    getAttributeType({ dispatch, commit }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesTypes.getOne',
          payload
        },
        { root: true }
      )
        .then((response) => {
          commit('setCurrentlyEditedAttribute', response.data)
        })
        .catch((e) => {
          throw e
        })
    },
    updateAttributesType({ dispatch, commit }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesTypes.update',
          payload
        },
        { root: true }
      )
        .then((response) => {
          commit('setCurrentlyEditedAttribute', response.data)
          return response.data
        })
        .catch((e) => {
          throw e
        })
    },
    createAttributesType({ dispatch }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesTypes.create',
          payload
        },
        { root: true }
      )
        .then((response) => {
          return response.data
        })
        .catch((e) => {
          throw e
        })
    },
    deleteAttributeType({ dispatch }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesTypes.delete',
          payload
        },
        { root: true }
      )
        .then(() => {})
        .catch((e) => {
          throw e
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/attributes-types.js